export const RequestExtension_Appeals_uischema = (caseNumber) => {
  return {
    name: "Request Extension",
    pageInfo: {
      text: "Use this form to upload documents to your submitted application. Uploaded documents will be added to case documents. Please check the correspondence issued for details on what is required for your case.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            value: "Extension Request",
            widget: "text",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "Request_Extension_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "Extension Request" },
            accept_multiple: true,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
        ],
      },
    ],
  };
};
